import React, { useRef } from 'react'
import _ from "lodash"
import moment from "moment"
import { Row, Col, Button, CardFooter } from "reactstrap"
import { useTranslation } from 'react-i18next'

import i18n, { getDir } from 'utils/translation/i18n'
import Form from 'main_views/components/Form/form_v2'
import Modal from "main_views/components/Modal"
import logo from 'assets/img/logo.png';
import ReactToPrint, { useReactToPrint } from 'react-to-print';

export default class Print extends React.Component {

   constructor(props) {
      super(props)
      this.state = {}

      this.setAnswerForm = this.setAnswerForm.bind(this)
   }

   setAnswerForm(answerForm = null) {
      this.setState({ answerForm })
   }

   render() {

      let { ticket, staffs } = this.props
      let { approvedBy, redirects, form } = ticket

      // merge and sort the approves & redirects
      let logs = { ...approvedBy, ...redirects }
      logs = _.orderBy(logs, info => moment(info.date, 'YYYY-MM-DD hh:mm:ss'))

      let title = ('#' + ticket?.number) ?? ''
      let subTitle = ticket.form.name
      let lastApprovedIndex = _.size(logs) - 1

      return (
         <div id="print">

            <div className="onlyShowInPrint text-center">

               <img src={logo} style={{ height: '3cm' }} className='mb-3' />

               {subTitle && (
                  <h5 className="modal-title" id="myModalLabel">
                     {subTitle}
                  </h5>
               )}

               <br />
               <hr />

               <TicketMainInfo title={title} ticket={ticket} />

               <hr />

            </div>

            <p className='no-print'><b>{i18n.t('requester_name')}: </b>{ticket.requesterName}</p>

            <div className='mx-3'>
               <Form
                  inputs={ticket.form.data}
                  filesUrls={ticket.filesUrls}
                  onChange={() => { }}
                  readOnly={true}
               />
            </div>

            <hr />

            {/*Display Tickets Approves List */}

            <div className='p-4'>

               <h4 className='text-black'>Log</h4>

               {_.isEmpty(logs) && (
                  <Row className='m-2 justify-content-center'>
                     <p>{i18n.t('no_approves_yet')}</p>
                  </Row>
               )}

               {/* show approvedBy & redirects lists (ordered by date) */}
               {!_.isEmpty(logs) && (
                  _.map(logs,
                     (staff, key) =>
                        <LogInfo
                           index={key}
                           staff={staff}
                           showAnswerForm={this.setAnswerForm}
                           lastApprovedIndex={lastApprovedIndex}
                           ticketState={(!ticket.inProgress && ticket.step !== "Canceled") ? _.get(ticket, 'step', '') : ''} // the canceled state has nothing to do with loges 
                           isDirected={_.has(staff, 'directedBy')}
                        />
                  )
               )}
            </div>

            <hr />

            {/* Display the answer form modal */}
            {this.state?.answerForm && (

               <Modal
                  isOpen={this.state.answerForm}
                  toggle={() => this.setAnswerForm()}
                  title={i18n.t('the_answer_form')}
                  removeBodyPaddings={true}
                  customFooter={
                     <ReactToPrint
                        trigger={() => <Button color="success" className="float-right mx-3">{i18n.t('print')}</Button>}
                        content={() => this.componentRef}
                     />
                  }
               >

                  <div
                     id="print"
                     style={{ minHeight: '50vh' }}
                     className='p-3'
                     ref={el => (this.componentRef = el)}>

                     {/* logo & main info's */}
                     <AnswerFormMainInfo
                        title={title}
                        subTitle={subTitle}
                        answerForm={this.state.answerForm}
                     />

                     {/* the answer form */}
                     <Form
                        inputs={this.state.answerForm.answerFormData}
                        readOnly={true}
                     />

                  </div>

               </Modal>
            )}

         </div>
      );
   }
}

let getStrFromFirestoreTime = (time, showTime = true) => moment(time.toDate()).format('YYYY-MM-DD' + (showTime ? ' hh:mm:ss' : ''))

let borderStyle = '1px solid #838383'

const LogInfo = ({ staff, showAnswerForm, index, lastApprovedIndex, ticketState, isDirected }) => (
   <div key={_.get(staff, 'id')} className='text-start'>

      <Row className='text-capitalize'>
         <Col md='6' xs='6' className='py-2 px-0'>
            <span className='font-size-10'>{_.get(staff, isDirected ? 'directedByName' : 'approvedName', '')}</span>
         </Col>
         <Col md='3' xs='3' className='py-2 px-0'>
            {/* The if statment just for old tickets (doesn't has 'action' field) */}
            <span className='font-size-10'>{staff.action ? i18n.t(staff.action) : (isDirected ? i18n.t('redirect') : (ticketState && lastApprovedIndex == index) ? i18n.t(ticketState.toLowerCase()) : i18n.t('approved'))}</span>
         </Col>
         <Col md='3' xs='3' className='py-2 px-0'>
            <span className='font-size-10'>{moment(_.get(staff, 'date')).format('YYYY-MM-DD HH:mm')}</span>
         </Col>
      </Row>

      <Row className='' style={{ minHeight: '10vh', border: borderStyle }}>
         <Col md='12' xs='12' className='p-2'>
            <span className='font-size-10'> {_.get(staff, 'message', 'no message')}</span>
         </Col>
      </Row>

      <Row className="pb-2 mb-4" style={{ borderBottom: borderStyle }}>

         <Col md='12' xs='12' className='py-2 px-0'>
            <span className='font-size-10'>{i18n.t('attatchments')}</span>
         </Col>

         <Col md='12' xs='12' className=''>

            {/* answer form model */}
            {!_.isEmpty(staff?.answerFormData) && (
               <>
                  <Button onClick={() => showAnswerForm({ ...staff })} color="neutral" size='sm'>
                     <ins>{i18n.t('show_the_answer_form')}</ins>
                  </Button>
               </>
            )}

            {/* attatchment links */}
            {!_.isEmpty(staff.attatchment) && (
               _.map(staff.attatchment, file => (
                  <>
                     <a key={file.name} href={file.url} target="_blank" className='px-2'>{file.name}</a>
                     <br />
                  </>
               ))
            )}


         </Col>
      </Row>


   </div>
)

let TicketMainInfo = ({ title, ticket }) => (
   <Row style={{ textAlign: 'start' }} className='mx-3' dir={getDir()}>
      <Col>

         <p><b>{i18n.t('ticket_number')}:</b> {title} </p>
         <p><b>{i18n.t('requester_name')}: </b>{ticket.requesterName}</p>
         {ticket.priority && (
            <p><b>{i18n.t('priority')}: </b> {i18n.t(ticket.priority) ?? ''} </p>
         )}

      </Col>

      <Col>

         <p><b>{i18n.t('opened_at')}: </b> {getStrFromFirestoreTime(ticket.openedAt)} </p>
         {ticket.dueDate && (
            <p><b>{i18n.t('due_date')}: </b> {getStrFromFirestoreTime(ticket.dueDate, false)} </p>
         )}
         {(ticket.inProgress && ticket.step) && (
            <p><b>{i18n.t('step')}: </b> {ticket.step} </p>
         )}
         {(!ticket.inProgress) && (
            <p><b>{i18n.t('state')}: </b> {ticket.step} </p>
         )}
         {ticket.closedAt && (
            <p><b>{i18n.t('closed_at')}: </b> {ticket.closedAt} </p>
         )}

      </Col>

   </Row>
)

let AnswerFormMainInfo = ({ title, subTitle, answerForm }) => (
   <div className="onlyShowInPrint text-center">

      <img src={logo} style={{ height: '3cm' }} className='mb-3' />

      {subTitle && (
         <>
            <h5 className="modal-title" id="myModalLabel">
               {subTitle}
            </h5>
            <p className="modal-title" id="myModalLabel">
               {i18n.t('answer_form')}
            </p>
         </>
      )}

      <br />
      <hr />

      <Row style={{ textAlign: 'start' }} className='mx-3' dir={getDir()}>

         <Col>
            <p><b>{i18n.t('ticket_number')}:</b> {title} </p></Col>
         <Col>
            <p><b>{i18n.t('approved_by')}: </b>{_.get(answerForm, 'approvedName', '')}</p>
         </Col>
         <Col>
            <p><b>{i18n.t('date')}:</b> {moment(_.get(answerForm, 'date')).format('YYYY-MM-DD')} </p>
         </Col>

      </Row>

      <Row style={{ textAlign: 'start' }} className='mx-3' dir={getDir()}>

         <Col>
            <p><b>{i18n.t('message')}: </b> {_.get(answerForm, 'message', '')} </p>
         </Col>

      </Row>

      <hr />

   </div>
)
